const CLOUDINARY_IMAGE_HOST = 'cms.cloudinary.vpsvc.com'
const NO_COOKIE = '?no_cookie=true'
const BREAKPOINTS = ['320w', '480w', '768w', '1024w', '1440w', '1920w', '2560w', '3840w']

export function getCloudinaryImage(imageSrc: string): string {
  if (!imageSrc || !imageSrc.includes(CLOUDINARY_IMAGE_HOST)) {
    return imageSrc
  }

  return `${imageSrc}${NO_COOKIE}`
}

export default function getResponsiveCloudinaryImage(imageSrc: string): string {
  if (!imageSrc || !imageSrc.includes(CLOUDINARY_IMAGE_HOST)) {
    return imageSrc
  }

  return BREAKPOINTS.map((breakpoint) => {
    const breakpointValue = breakpoint.replace('w', '')

    const newImageSrc = imageSrc
      .replace(/(,)?(w_[0-9]+)(,|\/)?/, '')
      .replace('/upload/', `/upload/w_${breakpointValue}/`)
      .replace('f_auto/', 'f_avif/')

    return `${newImageSrc}${NO_COOKIE} ${breakpoint}`
  }).join(',')
}

export function getBlurredCloudinaryImage(imageSrc: string) {
  if (!imageSrc || !imageSrc.includes(CLOUDINARY_IMAGE_HOST)) {
    return imageSrc
  }

  return `${imageSrc
    .replace(/(,)?(w_[0-9]+)(,|\/)?/, '')
    .replace('/upload/', `/upload/w_320/`)
    .replace('f_auto/', 'f_avif/')}${NO_COOKIE}`
}
